import type { Theme } from '@mui/material';

export const styles = {
  flag: (priority: boolean) => (theme: Theme) => ({
    color: priority ? theme.colors.primary[500] : theme.colors.neutral[500],
  }),
};
